module.exports = __webpack_public_path__ + "static/media/madfit-3.bbff4a75.jpg";